import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import { useRouter } from 'next/router';
import Form from 'components/contact/Form';
import Point from 'components/contact/point-component';
import LayoutContainer from 'components/layout/LayoutContainer';
import { Breadcrumbs } from 'components/widgets';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'store/actions';

const serverUrlImages = process.env.REACT_APP_SERVER_URL_IMAGES;
const facebook = `${serverUrlImages}/icons/contact/facebook.svg`;
const linkedIn = `${serverUrlImages}/icons/contact/linked-in.svg`;
const twitter = `${serverUrlImages}/icons/contact/twitter.svg`;
const instagram = `${serverUrlImages}/icons/contact/instagram.svg`;

const ContactPage = (props) => {
	const router = useRouter();
	const canonicalURL =
		process.env.REACT_APP_DOMAIN_URL + (router?.asPath || router?.pathname);

	const [routes] = useState([
		{
			name: 'Inicio',
			pathname: '/',
			asPath: '/'
		},
		{
			name: 'Contacto',
			pathname: router?.pathname,
			asPath: router?.asPath
		}
	]);

	useEffect(() => {
		const tagManagerArgs = {
			dataLayer: {
				event: 'pageview',
				pageTitle:
					'Contáctanos para seguir cuidando la salud de tu familia, sin importar las distancias'
			}
		};
		TagManager.dataLayer(tagManagerArgs);
	}, []);

	return (
		<LayoutContainer>
			<style global jsx>
				{`
					.map-contact {
						background-image: url(${serverUrlImages}/images/mapa.svg);
						background-position: top center;
						background-repeat: no-repeat;
						background-size: auto;
						height: 380px;
						width: 100%;
						position: relative;
						margin-top: 48px;
					}

					.map-contact > .point {
						position: absolute;
					}

					.map-contact > .point.one {
						top: 19%;
						left: 52%;
					}

					.map-contact > .point.two {
						top: 15%;
						left: 18%;
					}
					.map-contact > .point.six {
						top: 65%;
						left: 58%;
					}
					@media only screen and (min-width: 1920px) and (max-width: 5000px) {
						.map-contact > .point.two {
							top: 15%;
							left: 25%;
						}
					}

					.map-contact > .point.eight {
						bottom: -2%;
						left: 42%;
					}

					@media only screen and (min-width: 1480px) and (max-width: 1919px) {
						.map-contact > .point.two {
							top: 15%;
							left: 22%;
						}
					}

					@media only screen and (min-width: 1920px) and (max-width: 5000px) {
						.map-contact > .point.two {
							top: 15%;
							left: 25%;
						}
					}

					@media only screen and (min-width: 960px) and (max-width: 1279px) {
						.map-contact > .point.two {
							top: 15%;
							left: 8%;
						}
					}

					@media only screen and (min-width: 600px) and (max-width: 959px) {
						.map-contact {
							background-position-x: 30%;
							background-position-y: top;
						}
						.map-contact > .point.one {
							top: 19%;
							left: 78%;
						}
						.map-contact > .point.two {
							top: 15%;
							left: 2%;
						}
						.map-contact > .point.six {
							top: 65%;
							left: 85%;
						}
					}
					@media only screen and (max-width: 599px) {
						.map-contact {
							background-position-x: 38%;
							background-position-y: top;
						}
						.map-contact > .point.one {
							top: 19%;
							left: 82%;
						}
						.map-contact > .point.two {
							top: 15%;
							left: 12%;
						}
						.map-contact > .point.six {
							top: 65%;
							left: 90%;
						}
					}
				`}
			</style>
			<div className="content background-content bg-gray-100">
				<Head>
					<title>
						Contáctanos para seguir cuidando la salud de tu familia, sin
						importar las distancias
					</title>
					<meta
						name="description"
						content="Todos los puntos de contacto para darte  información sobre asistensi, el mejor seguro para emergencias médicas con atención médica inmediata"
					/>
					<link rel="canonical" href={canonicalURL} />
				</Head>

				{/*<div className="contact-page">*/}
				<div className="pb-20 h-full">
					<div className="map-contact">
						{/* <Point className="one" />
            <Point className="two" /> */}
						{/* <Point className="three" /> */}
						{/* <Point className="four" /> */}
						{/* <Point className="five" /> */}
						{/* <Point className="six" /> */}
						{/* <Point className="seven" /> */}
						{/* <Point className="eight" /> */}
					</div>

					<Breadcrumbs routes={routes} />

					<div className="flex flex-col items-center justify-center py-16">
						<h2 className="font-poppins font-bold container text-pink-500 text-base text-center mb-4">
							Desde cualquier país del mundo
						</h2>
						<h1 className="font-poppins text-purple-500 text-center font-bold container leading-snug text-4xl">
							Contáctanos y empieza a cuidar la salud de los tuyos
						</h1>
					</div>

					<div className="flex flex-col md:flex-row justify-center container">
						<Form actions={props.actions} />

						<div className="social-content w-full md:w-2/5">
							<div className="flex flex-col bg-white border border-purple-300 rounded-xl p-10">
								<span className="text-purple-500 font-poppins text-normal font-bold pb-2">
									Visítenos en nuestra oficina ubicada en:
								</span>
								<p className="mb-6">
									<span className="text-purple-500 text-normal">
										Ave. Gustavo Mejía Ricart No. 106, Torre Piantini, Local
										201, Sector Piantini, Santo Domingo de Guzmán, República
										Dominicana.
									</span>
								</p>

								<span className="text-purple-500 font-poppins text-normal font-bold mb-4">
									Llámanos a través de nuestros números de contacto:
								</span>

								<p className="mb-2">
									<span className="text-purple-500 text-normal">
										República Dominicana:&nbsp;
									</span>
									<span className="text-normal text-purple-300">
										<a
											href="tel:+18095477007"
											rel="noopener noreferrer"
											className="text-purple-300"
										>
											+1 (809) 547 7007
										</a>
									</span>
								</p>
								<p className="mb-2">
									<span className="text-purple-500 text-normal">
										Estados Unidos:&nbsp;
									</span>
									<span className="text-normal text-purple-300">
										<a
											href="tel:+19179095661"
											rel="noopener noreferrer"
											className="text-purple-300"
										>
											+1 (917) 909 5661
										</a>
									</span>
								</p>

								<p className="mb-2">
									<span className="text-purple-500 text-normal">España:</span>
									<span className="text-normal text-purple-300">
										<a
											href="tel:+34911231079"
											rel="noopener noreferrer"
											className="text-purple-300"
										>
											+34 (911) 231 079
										</a>
									</span>
								</p>
							</div>

							<div className="flex justify-around mt-14">
								<a
									href="https://www.facebook.com/Asistensird-106592334743542/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src={facebook}
										alt="logo facebook"
										className="w-5 c-p icon-hover m-r20"
									/>
								</a>
								<a
									href="https://www.linkedin.com/company/asistensi"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src={linkedIn}
										alt="logo linked in"
										className="w-5 c-p icon-hover m-r20 m-l20"
									/>
								</a>
								<a
									href="https://twitter.com/Asistensi_rd?s=09"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src={twitter}
										alt="logo twitter"
										className="w-5 c-p icon-hover m-r20 m-l20"
									/>
								</a>
								<a
									href="https://instagram.com/asistensi.rd?igshid=l2ga8u4etofs"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src={instagram}
										alt="logo instagram"
										className="w-5 c-p icon-hover m-l20"
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LayoutContainer>
	);
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(actions, dispatch) };
};

export default connect(null, mapDispatchToProps)(ContactPage);
